export const nextEvent = <T extends Event | CustomEvent>(
    eventTarget: EventTarget,
    eventName: string,
) => {
    return new Promise<T>((res) => {
        const callback = (event: T) => {
            eventTarget.removeEventListener(eventName, callback);
            res(event);
        };

        eventTarget.addEventListener(eventName, callback);
    });
};
